export type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

export const redirectDestination = 'https://www.athleticpropulsionlabs.com/';
